// extracted by mini-css-extract-plugin
export var appIllustration = "AppIllustration-module--appIllustration--f3556";
export var appIllustrationScreen = "AppIllustration-module--appIllustrationScreen--ff096";
export var appIllustrationScreenHome = "AppIllustration-module--appIllustrationScreen--home--dc4d5";
export var appIllustrationScreenReimbursement = "AppIllustration-module--appIllustrationScreen--reimbursement--81501";
export var appIllustrationScreenTransition = "AppIllustration-module--app-illustration-screen-transition--ad645";
export var icon = "AppIllustration-module--icon--9fc3d";